import React, {useEffect, useState} from "react";
import HeaderBreadCrumb from "../../BreadCrumb/Breadcrumb";
import Aux from "../../../hoc/Auxiliary"
import {DataTable} from 'primereact/datatable';
import {Column} from "primereact/column";
import classes from "./DataCollectionList.module.css"
import {isAuthorized} from "../../../api/authorization/authorization-service";
import {SelectButton} from 'primereact/selectbutton';
import DCListHeader from "./Header/DCListHeader";
import CreateDataCollectionButton from "./CreateDcButton/CreateDataCollectionButton";
import DataCollectionErrorList from "./Errors/DataCollectionErrorList";
import DCStatusFilter from "../../commun/DCStatusFilter/DCStatusFilter";
import StatusBodyTemplate from "../../commun/Table/StatusColumn/StatusBodyTemplate";
import {getDefaultColumnFilter, statusFilterProperties} from "../../../api/utils/filterProperties";
import ActionColumnPublishedDc from "./ActionBody/ActionColumnPublishedDc";
import {Chip} from "primereact/chip";
import ModelVersionColumn from "./ModelVersionColumn/ModelVersionColumn";
import DraftDataCollections from "./DraftDataCollectionsList/DraftDataCollections";
import {classNames} from "primereact/utils";
import {ConfirmDialog} from "primereact/confirmdialog";
import {getDCDetailsById} from "../../../api/dataCollection/dataCollection-service";
import {Skeleton} from 'primereact/skeleton';
import DataCollectionsInProgress from "./DataCollectionInProgressList/DataCollectionsInProgress";
import TagList from "../../DataUpload/CategoriesData/CategoryData/TagList";
import DCTagsFilter from "../../commun/DCTagsFilter/DCTagsFilter";
import keycloak from "../../../keycloak";

import {
    getUserFilters,
    saveUserFilters,
    updateSorters,
    updateStatus
} from "../../../api/dataCollection/user-filters-service";
import TemplatePaginatorWithSavingValue from "../../commun/TemplatePaginator/TemplatePaginatorWithSavingValue";
import {Badge} from "primereact/badge";
import {MeterGroup} from "primereact/metergroup";
import {StatusCode} from "../../../entities/StatusContext";
import {ReuseDataOptions} from "../../../enums/ReuseDataOptions";

const DataCollectionsList = ({
                                 dcListOthers,
                                 statusList,
                                 dcListDraft,
                                 reload,
                                 setReload,
                                 dcDetails,
                                 dcListInProgress,
                                 refreshList
                             }) => {
    const [loadingExpandedRow, setLoadingExpandedRow] = useState(false);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [value, setValue] = useState(StatusCode.PUBLISHED);
    const options = [StatusCode.PUBLISHED, StatusCode.DRAFT, StatusCode.DC_CREATION_IN_PROGRESS];
    const [dcList, setDcList] = useState([]);

    const [draftList, setDraftList] = useState([])
    const [progressList, setProgressList] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const [progressMsg, setProgressMsg] = useState('Creating');
    const [idDeleting, setIdDeleting] = useState([]);
    const isSelectable = (id) => !idDeleting.includes(id);
    const rowClassName = (data) => {
        return isSelectable(data.id) ? 'custom-datatable-loading' : 'p-disabled'
    };
    const tags = [...new Map(dcListOthers?.flatMap(dc => dc.allTags).map(tag => [tag.name, tag])).values()];
    const [initialTags, setInitialTags] = useState([...tags.filter(tag => keycloak.idTokenParsed.group.includes(tag.name))])
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [sortField, setSortField] = useState();
    const [sortOrder, setSortOrder] = useState();
    const [loadingOthersDcList, setLoadingOthersDcList] = useState(true);
    const [loadingDraftDcList, setLoadingDraftDcList] = useState(true);
    const [loadingProgressDcList, setLoadingProgressDcList] = useState(true);
    const [filters, setFilters] = useState(statusFilterProperties);

    const statusFilterTemplate = () => {
        return <DCStatusFilter selectedStatus={selectedStatus}
                               tags={initialTags}
                               statusList={statusList}
                               onchange={applyFilter}/>
    }

    const tagsFilterTemplate = () => {
        return <DCTagsFilter dataCollectionsList={dcListOthers} filterDataCollections={setDcList}
                             TagsList={tags}
                             status={selectedStatus}
                             initialTags={initialTags}
                             onChange={applyFilter}
        />
    }

    const applyFilter = (tags, status) => {
        if (dcListOthers !== undefined) {
            let result = [...dcListOthers];

            if (tags.length !== 0) {
                result = result.filter(dc =>
                    tags.some(tag => dc.allTags.some(dcTag => dcTag.id === tag.id))
                );
            }
            if (status.length !== 0) {
                result = [...result
                    .filter(e1 => status.map(v => v.code).some(val => e1.dataStatus.code.includes(val)))]
            }
            setInitialTags(tags);
            setSelectedStatus(status);
            setDcList(result);
            saveUserFilters(keycloak.idTokenParsed.sub, tags, rows, cleanFilters(filters));
            updateStatus(keycloak.idTokenParsed.sub, status)
        }
    };

    const cleanFilters = (filters) => {
        const newFilters = {};
        Object.keys(filters).forEach(key => {
            if (key && key !== "null") {
                newFilters[key] = filters[key];
            }
        });
        return newFilters;
    };

    useEffect(() => {
        if (Array.isArray(dcListOthers)) {
            setDcList([...dcListOthers]);
            setLoadingOthersDcList(false);
        } else {
            setLoadingOthersDcList(true);
        }
    }, [dcListOthers]);

    useEffect(() => {
        if (Array.isArray(dcListDraft)) {
            setDraftList([...dcListDraft]);
            setLoadingDraftDcList(false);
        } else {
            setLoadingDraftDcList(true);
        }

    }, [dcListDraft]);

    useEffect(() => {
        if (Array.isArray(dcListInProgress)) {
            setProgressList([...dcListInProgress]);
            setLoadingProgressDcList(false);
        } else {
            setLoadingProgressDcList(true);
        }

    }, [dcListInProgress]);

    useEffect(() => {
        var selectedTag = [...tags.filter(tag => keycloak.idTokenParsed.group.includes(tag.name))];
        var status = [];
        getUserFilters(keycloak.idTokenParsed.sub).then(res => {
            if (res.status === 200) {
                if (res.content) {
                    selectedTag = res.content.tags;
                    setRows(res.content.numberDCPerPage);
                    status = res.content.status;
                    setSortOrder(res.content.sortingOrder);
                    setSortField(res.content.sortingField);
                    const savedFilters = res.content.filters;
                    if (savedFilters) {
                        setFilters(JSON.parse(savedFilters));
                    }
                }
            }
            applyFilter(selectedTag, status);
        });
    }, [dcListOthers]);

    function calculateProgressValues(progressInfos) {
        if (progressInfos.length === 0) {
            return [{color: 'gray', value: 0}]
        } else {
            return progressInfos.map(x => {
                return {'color': x.color, "value": x.percentage}
            });
        }

    }

    const validationProgress = (row) => (
        <div className="card flex justify-content-center">< MeterGroup style={{width: "100%"}}
                                                                       values={calculateProgressValues(row['progressInfos'])}/>
        </div>);
    const header = (
        <DCListHeader>
            <div className="right-0 md-0 text-red font-bold flex align-items-center">
                <CreateDataCollectionButton/>
            </div>
        </DCListHeader>
    );

    const onCustomPage = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    }
    const actionsBodyTemplateForPublish = (rowData) => ((idDeleting.includes(rowData.id)) ?
        <div className="flex justify-content-around">
            <span className="vertical-align-middle"> {progressMsg} </span>
            <i className="pi pi-spin pi-spinner" style={{fontSize: '1.2rem', padding: '0.15rem'}}></i></div> :
        <ActionColumnPublishedDc rowData={rowData}
                                 setIdDeleting={setIdDeleting}
                                 setProgressMsg={setProgressMsg} idDeleting={idDeleting}
                                 isDcCreationInProgress={rowData.dataCollectionStatus.code === StatusCode.DC_CREATION_IN_PROGRESS}
                                 refreshList={refreshList}/>)
    const modelVersionColumnTemplate = (rowData) => (<ModelVersionColumn rowData={rowData}/>)


    const nameColumnStructure = (r) => {
        if (r['errorNotificationPresent'] && isAuthorized("AR032")) {
            return <DataCollectionErrorList row={r}/>
        } else {
            return r.name;
        }
    }
    const tagsColumnStructure = (r) => {
        return <div><TagList tags={r.allTags}></TagList></div>
    }
    const findDetailsById = (id) => {
        return expandedRows.filter(e => e.id === id)[0];
    }
    const rowExpansionTemplate = (data) => {
        let details = findDetailsById(data?.id)

        let groupedPermissions = groupPermissionsByParticipant(details.participants);
        let reuseDataOption = data?.copiedFrom?.reuseDataOption?.toUpperCase();

        return loadingExpandedRow ? <Skeleton width="90vw" height="4rem"></Skeleton> : (
            <div className="p-3" style={{width: '90vw'}}>
                {details.description !== "" &&
                    <div className={classes.description}><h5>Description :</h5>{details.description}</div>}
                {details.copiedFrom !== null && <h5>Copied From : {data.copiedFrom.copiedFromDc}</h5>}
                {details.copiedFrom !== null && reuseDataOption !== null &&
                    <h5>Reuse data option : {ReuseDataOptions[reuseDataOption]}</h5>}
                <h5>Categories :</h5>
                {<DataTable scrollable value={details.categories}>
                    <Column style={{width: '40%'}} field="name" header="Name" sortable></Column>
                    <Column header="Topics" body={topicsBodyTemplate}></Column>
                </DataTable>}
                <h5>Permissions :</h5>
                {<DataTable scrollable value={groupedPermissions}>
                    <Column style={{width: '20%'}} field="participant" header="User group" sortable></Column>
                    <Column header="Permissions" body={permissionsBodyTemplate}></Column>
                </DataTable>}
            </div>
        );
    };
    const topicsBodyTemplate = (cat) => {
        return <Aux>
            {cat.topics.map((s) => {

                return <Chip label={(
                    s.targetYearStart !== 0 ?
                        <div>{s.name}<b>({s.targetYearStart}-{s.targetYearEnd})</b></div> :
                        <div>{s.name}</div>
                )}
                             className={"mb-2"}/>
            })}
        </Aux>
    };
    const MarketNodeBodyTemplate = (p) => {
        return <Aux>{p.marketNodes.map((m) => {

            return <Chip label={m.name}
                         className={"mb-2"}/>
        })}</Aux>
    }
    const permissionsBodyTemplate = (p) => {
        return <DataTable style={{width: '100%'}} value={p.permissions}>
            <Column style={{width: '25%'}} field="permissionName" header="Permission" sortable></Column>
            <Column header="Market Nodes" body={MarketNodeBodyTemplate}></Column>
        </DataTable>

    }

    const groupPermissionsByParticipant = (participants) => {
        //group by participant name
        let data = []
        let groupedByParticipant = participants.reduce(function (r, a) {
            r[a.participant.name] = r[a.participant.name] || [];
            r[a.participant.name].push(a);
            return r;
        }, Object.create(null));
        //group by permission

        for (let key in groupedByParticipant) {
            let ar = []
            let p = groupedByParticipant[key].reduce(function (r, a) {
                r[a.permissionName.name] = r[a.permissionName.name] || [];
                r[a.permissionName.name].push(a.marketNode);
                return r;
            }, Object.create(null));
            for (let key in p) {
                // display only write access
                if (key === "Write") {
                    ar.push({permissionName: key, marketNodes: p[key]})
                }
            }
            groupedByParticipant[key] = ar
            data.push({"participant": key, "permissions": ar})
        }
        return data
    }

    const getDataCollectionDetails = async (e) => {
        let currentId = 0;
        for (let outerkey in e.data) {
            if (e.data[outerkey] === true) {
                currentId = outerkey
                break;
            }
        }
        let size = expandedRows.length
        let currentRows = expandedRows.filter(x => x.id != currentId)
        e.data = currentRows
        if (currentId !== 0 && size == currentRows.length) {
            await getDCDetailsById(currentId).then(res => {
                e.data = [...e.data, res]
            })
        }
        setExpandedRows(e.data)
    }
    const onSort = (event) => {
        setSortField(event.sortField);
        setSortOrder(event.sortOrder);
        updateSorters(keycloak.idTokenParsed.sub, event.sortField, event.sortOrder);
    };
    const renderStatusHeader = (elements, title) => {
        const count = elements.length;
        return (
            <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                <span>{title}</span>
                {count > 0 && <Badge style={{backgroundColor: "#487c84"}} value={count} severity="info"/>}
            </div>
        );
    };

    const onFilter = (e) => {
        setFilters(e.filters);
        saveUserFilters(keycloak.idTokenParsed.sub, initialTags, rows, cleanFilters(e.filters));

    };

    const handleColumnFilterClear = (col) => {
        const updated = {...filters};
        updated[col] = getDefaultColumnFilter(col);
        setFilters(updated);

        saveUserFilters(
            keycloak.idTokenParsed.sub,
            initialTags,
            rows,
            cleanFilters(updated)
        );
    };

    const othersDataCollections = () => {
        return (<div>
            <div className="card">
                <DataTable removableSort value={dcList} loading={loadingOthersDcList}
                           expandedRows={expandedRows} onRowToggle={(e) => {
                    setLoadingExpandedRow(true)
                    getDataCollectionDetails(e)
                    setLoadingExpandedRow(false)
                }}
                           rowExpansionTemplate={rowExpansionTemplate}
                           expandedRowIcon="pi pi-chevron-up"
                           collapsedRowIcon="pi pi-chevron-down"
                           dataKey="id"
                           header={header}
                           size="small"
                           stripedRows
                           showGridlines
                           sortField={sortField}
                           sortOrder={sortOrder}
                           onSort={(e) => onSort(e)}
                           filters={filters}
                           onFilter={onFilter}
                           paginator paginatorTemplate={TemplatePaginatorWithSavingValue}
                           first={first} rows={rows} onPage={onCustomPage}
                           paginatorClassName="justify-content-end" className="mt-6 custom-datatable-loading"

                           rowClassName={rowClassName}
                           style={{overflow: "visible", whiteSpace: "normal", minHeight: '300px'}}
                >
                    <Column expander={true} style={{minWidth: '2rem', maxWidth: '2.5rem'}}/>
                    <Column
                        field="name"
                        style={{minWidth: "7rem", maxWidth: "9rem", whiteSpace: 'normal', wordWrap: 'break-word'}}
                        body={(r) => nameColumnStructure(r)}
                        sortable
                        header="Name"
                        filter
                        onFilterClear={() => handleColumnFilterClear("name")}
                    />
                    <Column field="dataStatus.name" sortable header={renderStatusHeader(selectedStatus, "Status")}
                            filterMenuStyle={{width: '14rem', height: '6rem'}}
                            style={{minWidth: '10rem', whiteSpace: 'normal', wordWrap: 'break-word'}}
                            showFilterMatchModes={false}
                            body={StatusBodyTemplate}
                            filter
                            showApplyButton={false}
                            showClearButton={false}
                            filterElement={statusFilterTemplate}/>
                    <Column header="Publish Progress" body={validationProgress} style={{width: "8rem"}}/>
                    <Column field="startFrom" header="Open from" style={{width: "5rem"}}/>
                    <Column field="deadline" header="Deadline" style={{width: "5rem"}}/>
                    <Column field="participatingCountries"
                            header="Participants" style={{width: "6rem"}}/>
                    <Column field="modelVersionName" header="PEMMDB Version" body={modelVersionColumnTemplate}
                            style={{
                                minWidth: "7rem",
                                maxWidth: "8rem",
                                whiteSpace: 'normal',
                                wordWrap: 'break-word'
                            }}
                            filter
                            onFilterClear={() => handleColumnFilterClear("modelVersionName")}/>
                    <Column
                        field="allTags"
                        style={{
                            minWidth: "8rem",
                            maxWidth: "8rem",
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            overflow: "visible"
                        }}
                        filterMenuStyle={{width: '14rem', height: '6rem'}}
                        body={(r) => tagsColumnStructure(r)}
                        sortable
                        header={renderStatusHeader(initialTags, "Tags")}
                        filter
                        showFilterMatchModes={false}
                        showApplyButton={false}
                        showClearButton={false}
                        filterElement={tagsFilterTemplate}/>
                    <Column body={actionsBodyTemplateForPublish} header="Actions "
                            style={{minWidth: "12rem", width: '12rem'}}/>
                </DataTable>
                <ConfirmDialog/>
            </div>
        </div>)

    }


    const draftDataCollections = () => {
        return (<DraftDataCollections dcListDraft={dcListDraft} setDraftList={setDraftList} draftList={draftList}
                                      loading={loadingDraftDcList}
                                      header={header} first={first} rows={rows} onCustomPage={onCustomPage}/>)

    }

    const dataCollectionsInProgress = () => {
        return (<DataCollectionsInProgress dcListInProgress={progressList}
                                           setDcListInProgress={setProgressList}
                                           rows={rows} rowExpansionTemplate={rowExpansionTemplate} header={header}
                                           loading={loadingProgressDcList}
                                           first={first} onCustomPage={onCustomPage}/>)

    }
    const selectStatus = (val) => {
        if (val != null) {
            setValue(val);
        }
    }
    const showSelectButton = () => {
        if (isAuthorized("AR08")) {
            return (<SelectButton
                    value={value}
                    options={options}
                    className={classNames(classes.selectBtn, "ml-0")}
                    onChange={(e) => selectStatus(e.value)}/>
            )
        } else {
            return null;
        }
    }
    const showDataCollections = () => {
        if (isAuthorized("AR08")) {
            return (getDataCollections());
        } else {
            return (othersDataCollections());
        }
    }
    const getDataCollections = () => {
        if (value === StatusCode.DRAFT)
            return draftDataCollections()
        else if (value === StatusCode.PUBLISHED)
            return othersDataCollections()
        else {
            return dataCollectionsInProgress()
        }
    }
    return (
        <Aux>
            <HeaderBreadCrumb items={["Data Collections"]}/>
            {showSelectButton()}
            {showDataCollections()}
        </Aux>
    )
}
export default DataCollectionsList;
